import { ContractExplorer } from '@/components/ContractExplorer';

const Index = () => {
  return <ContractExplorer />;
};

export default Index;
